import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { BackgroundColors } from '@picsart/design-system/foundation/colors';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { StackingContext } from '@picsart/design-system/foundation/stackingContext';
import { Easings } from '@picsart/design-system/foundation/easings';
import { hideScrollbars } from '@picsart/design-system/styleUtils/hideScrollbars';

const useStyles = createUseStyles(
  {
    container: {
      position: 'sticky',
      top: 0,
      zIndex: StackingContext.layout,
      backgroundColor: BackgroundColors.base,
      padding: [Spacings.s8, Spacings.s16, 0],
      marginBottom: Spacings.s8,
    },
    /**
     * Relative wrapper the sliding pill is measured against and positioned in,
     * and the horizontal scroller for the row. The pill is absolute *inside*
     * this box, so it scrolls with the segments; the measurement adds
     * `scrollLeft` to stay in the same content coordinate space.
     */
    wrap: {
      position: 'relative',
      display: 'flex',
      maxWidth: '100%',
      overflowX: 'auto',
      overscrollBehavior: 'contain',
      WebkitOverflowScrolling: 'touch',
      ...hideScrollbars,
    },
    pill: {
      position: 'absolute',
      left: 0,
      zIndex: 0,
      borderRadius: CornerRadius.r8,
      backgroundColor: BackgroundColors.tint2,
      transition: `transform 0.25s ${Easings.ease}, width 0.25s ${Easings.ease}`,
      pointerEvents: 'none',
    },
    /**
     * DS lays segments out as `repeat(<count>, 1fr)` — equal columns, each with
     * `min-width: 0`, so the longest label ends up ellipsized ("Motio…") as
     * soon as the labels outgrow the row. Replacing the template with
     * content-sized implicit columns sizes every tab to its own label; the row
     * then overflows and `wrap` scrolls it. Count-independent, so a new tool
     * from `HOME_TOOLS` needs no change here.
     */
    segments: {
      position: 'relative',
      zIndex: 1,
      width: 'max-content',
      maxWidth: 'none',
      flex: '0 0 auto',
      backgroundColor: 'transparent',
      gridTemplateColumns: 'none',
      gridAutoFlow: 'column',
      gridAutoColumns: 'max-content',
    },
    segment: {
      backgroundColor: 'transparent',
    },
  },
  { name: 'HomeToolTabs' }
);

export default useStyles;
